// src/pages/PerformancePage.jsx
import React from "react";
import Chart from "react-apexcharts";
import { FaCalendar, FaCalendarAlt, FaClock } from "react-icons/fa";
import { ProgressBar } from "react-bootstrap";

export default function PerformancePage() {
  const percentage = 60;

  const chartOptions = {
    chart: {
      type: "donut",
    },
    labels: ["%Passed", "%Failed"],
    colors: ["#F9D4FD", "#A902BA"],
    legend: {
      position: "right",
    },
  };

  const chartSeries = [60, 40];

  return (
    <div className="p-4 bg-white rounded-lg shadow-md m-5 min-h-screen">
      <h1 className="text-[20px] font-bold text-[#400167] mb-4">
        Students Performance
      </h1>
      <div className="grid grid-cols-2">
        <div
          className="border w-[450px] p-3 rounded-lg"
          style={{ border: "1px solid rgba(0,0,0,0.3)" }}
        >
          <h2 className="text-[20px] font-bold text-[#000000]">Lesson Title</h2>
          <div className="flex items-center my-4">
            <span className="text-gray-600 flex items-center gap-2">
              <FaCalendarAlt size={20} className="text-[#5002D0]" />
              <span className="text-[16px] font-regular">24/05/2024</span>
            </span>
            <span className="ml-4 text-gray-600 flex items-center gap-2">
              <FaClock ize={20} className="text-[#5002D0]" />
              <span className="text-[16px] font-regular">09:00</span>
            </span>
          </div>

          <div className="my-2">
            <div className="mb-2">
              <QuestionCount title="Duration" count="10 Minutes" />
            </div>
            <div className="mb-2">
              <QuestionCount title="Number of questions" count="25" />
            </div>
            <div className="mb-2">
              <QuestionCount title="Score per question" count="4" />
            </div>

            <div className="mb-2 w-[320px] h-[150px] border-2 rounded-lg">
              <div
                className="flex items-center rounded-lg border-[1.5px]  bg-white h-[40px] w-[320px] mb-1"
                style={{ border: "1px solid rgba(0,0,0,0.3)" }}
              >
                <span
                  className="text-[16px] text-gray-700 h-[40px] w-full font-semibold py-2 px-3 rounded-lg "
                  style={{ backgroundColor: "rgba(52,1,103,0.1)" }}
                >
                  Description
                </span>
              </div>
              <span className="text-[14px] font-light">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Deserunt asperiores omnis esse rerum cum harum iusto dolor
                suscipit repudiandae qui.
              </span>
            </div>
            <div className="mb-2">
              <QuestionCount title="Question Category" count="WASSCE" />
            </div>
          </div>
        </div>

        {/* Result */}
        <div
          className="w-[550px] p-4 rounded-lg"
          style={{ border: "1px solid rgba(0,0,0,0.3)" }}
        >
          <h2 className="text-[18px] font-bold text-[#400167]">Results</h2>
          <div className="fle my-4">
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="donut"
              width="380"
            />
          </div>
          <div className="mb-3 flex items-center gap-4">
            <span className="block font-bold text-[14px] bg-[#5002D0] w-[175px] text-white p-[0.7rem] rounded-s font-satoshi">
              Student name
            </span>
            <span
              className="w-[175px] p-[0.7rem] rounded-s font-semibold text-[14px font-satoshi"
              style={{ border: "1.5px solid rgba(0,0,0,0.2)" }}
            >
              Toms Browns
            </span>
          </div>
          <div className="mb-3 flex items-center gap-4">
            <span className="block font-bold bg-[#5002D0] w-[70px] p-[0.7rem] text-white  font-satoshi">
              Score
            </span>
            <span
              className="p-[0.7rem] w-[70px] "
              style={{ border: "1px solid rgba(0,0,0,0.2)" }}
            >
              15
            </span>
          </div>
          <div className="mb-3 flex items-center gap-4">
            <span className="font-bold bg-[#5002D0] w-[115px] p-[0.7rem] text-white  font-satoshi">
              Total score
            </span>
            <span
              className="w-[115px] p-[0.7rem]"
              style={{ border: "1px solid rgba(0,0,0,0.2)" }}
            >
              25
            </span>
          </div>
          <div className="mb-3 flex items-center gap-4">
            <span className="block font-bold bg-[#5002D0] w-[160px] p-[0.7rem] text-white  font-satoshi rounded-e">
              Time spent
            </span>
            <span
              className=" p-[0.7rem] rounded-e"
              style={{ border: "1px solid rgba(0,0,0,0.2)" }}
            >
              9 minutes 5 seconds
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function QuestionCount({ title, count }) {
  return (
    <div
      className="flex items-center rounded-lg border-[1.5px]  bg-white h-[40px] w-[320px] mb-1"
      style={{ border: "1px solid rgba(0,0,0,0.3)" }}
    >
      <span
        className="text-[16px] text-gray-700 h-[40px] w-[190px] font-semibold py-2 px-3 rounded-lg "
        style={{ backgroundColor: "rgba(52,1,103,0.1)" }}
      >
        {title}
      </span>
      <span className="text-[15px] font-normal text-[#000000] ml-5">
        {count}
      </span>
    </div>
  );
}
